
import { computed, ref } from 'vue'
import { storeToRefs,defineStore } from 'pinia';
import { useDynamicYieldStore } from '~/stores/dynamicYieldStore';
import {useLocaleStore} from '~/stores/localeStore'
interface ChatDynamicYieldData {
  experienceName?: string;
  name?: string;
  type?: string;
  [key: string]: any;
}

const CHATBOT_READY_EVENT = 'taia-chatbot-ready'
const CHATBOT_READY_MESSAGE_TYPES = new Set([
  'CHATBOT_READY',
  'chatbotReady',
  'TAIA_CHATBOT_READY'
])

const chatbotReady = ref(false)
const chatbotReadyVersion = ref(0)
let hasRegisteredChatbotReadyListeners = false

const markChatbotReady = () => {
  chatbotReady.value = true
  chatbotReadyVersion.value += 1
}

const handleChatbotMessage = (event: MessageEvent) => {
  const messageType = event.data?.type
  if (CHATBOT_READY_MESSAGE_TYPES.has(messageType)) {
    markChatbotReady()
  }
}

const ensureChatbotReadyListeners = () => {
  if (!import.meta.client || hasRegisteredChatbotReadyListeners) return

  window.addEventListener('message', handleChatbotMessage)
  window.addEventListener(CHATBOT_READY_EVENT, markChatbotReady as EventListener)
  hasRegisteredChatbotReadyListeners = true
}

export const useIframeStore = defineStore('iframeStore', () => {
  ensureChatbotReadyListeners()
  const localeStore = useLocaleStore()
  const dyStore = useDynamicYieldStore();
  const { locale } = storeToRefs(localeStore)
  const inputSearchQuery = ref('');
  const nuxtApp = useNuxtApp();
  const config = nuxtApp.$config;
  const annonceMentHeight = ref(0);

const isDynamicYieldVariationData = computed<ChatDynamicYieldData>(() => {
  const myVariationData = dyStore.getCustomJSONVariationBySelector(config?.public?.dyCampaignKeyPhe ?? '');
  const taiaVariationData  = dyStore.getCustomJSONVariationBySelector(config?.public?.dyCampaignKeyTaia ?? '');
    return {
    ...taiaVariationData,
    ...myVariationData,
    data: {
      ...(taiaVariationData?.data ?? {}),
      ...(myVariationData?.data ?? {})
    },
  };
});

  const dynamicYieldData = computed(() => {
      return isDynamicYieldVariationData.value?.data ?? {};
  });

  const dynamicYieldPdpData = computed(() => {
    const myPdpVariationData = dyStore.getCustomJSONVariationBySelector(config?.public?.dyCampaignKeyPdp ?? '');
    return myPdpVariationData?.data?.variant || "CONTROL";
  });

  const dynamicYieldMobilePdpData = computed(() => {
    const myPdpVariationData = dyStore.getCustomJSONVariationBySelector(config?.public?.dyCampaignKeyMobilePdp ?? '');
    return myPdpVariationData?.data?.variant || "CONTROL";
  });

  const isEnableTaia = computed(() => {
    const isChatEnabled = config?.public?.chatIframeEnabled === 'Y';
    const isTaiaEnabled = locale.value?.country?.taiaEnabled ?? false;
    const isComponentEnabled = dynamicYieldData.value?.enabled ?? false;
    return isChatEnabled && isTaiaEnabled && isComponentEnabled;
  });

  function updateInputSearchQuery(value='') {
    inputSearchQuery.value = value
  }

  function sendMessageToChatbot(type, payload = {}) {
    window.postMessage(
      {
        source: 'TAIA_CHATBOT',
        type,
        payload,
      }
    );
  }
  
  return {
    inputSearchQuery,
    annonceMentHeight,
    chatbotReady,
    chatbotReadyVersion,
    isEnableTaia,
    dynamicYieldData,
    dynamicYieldPdpData,
    dynamicYieldMobilePdpData,
    updateInputSearchQuery,
    sendMessageToChatbot,
    isDynamicYieldVariationData
  };
});
